import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i9.6
import React from 'react';
import IconWrap from '../IconWrap';
const Premium = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M0 21v-4h1.778v2h12.444v-2H16v4z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.91 2.88L12 0H4v7H2.36L0 9.51l7.95 8.35 3-3.22c2.3724 1.3396 5.3285 1.0575 7.4048-.7066 2.0762-1.7641 2.832-4.6359 1.893-7.1935-.939-2.5576-3.3733-4.2582-6.0978-4.2599a6.64 6.64 0 0 0-2.24.4zM10 4C8.6637 5.1493 7.7423 6.8527 7.6424 8.6124A6.49 6.49 0 0 0 9.36 13.39l-1.47 1.55L2.75 9.5l.47-.5h2.67V2H10v2zm4.79 8.52v1.2h-1v-1.2a2.78 2.78 0 0 1-2.7-1.87h1.12a2.08 2.08 0 0 0 2.11 1.11c1.11 0 1.87-.44 1.87-1.2 0-.54-.37-.89-1.34-1.09l-1.5-.33c-1.17-.24-2.05-.75-2.05-1.82s1-1.87 2.49-1.95V4.28h1V5.4a2.58 2.58 0 0 1 2.35 1.79h-1.07a1.94 1.94 0 0 0-2-1c-1 0-1.71.42-1.71 1.13s.47.88 1.36 1.07l1.43.3c1.34.29 2.09.9 2.09 1.89 0 1.1-1.02 1.81-2.43 1.94h-.02z"
    }))));
};
Premium.displayName = 'Premium';
export default Premium;
